//ChooseColor

import React from "react";
export default (props) => {
  return (
    <>
      <div
        className="single-color"
        onClick={() => {
          props.colorClick(props.color);
        }}
      >
        <h1 className="choose-color-name">
          <h4>red : {props.color[0]}</h4>
          <h4>geen : {props.color[1]}</h4>
          <h4>blue : {props.color[2]}</h4>
        </h1>
      </div>
    </>
  );
};

// Loading;
